
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteLinkLicense = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'DELETE_LINK_LICENSE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'DELETE_LINK_LICENSE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'DELETE_LINK_LICENSE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'DELETE_LINK_LICENSE_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}
export default DeleteLinkLicense